// extracted by mini-css-extract-plugin
export default {"notificationBar":"NotificationBar_notificationBar__syCse","success":"NotificationBar_success__t2Wpb","error":"NotificationBar_error__mq60D","load":"NotificationBar_load__OXs-6"};